import { Link } from 'react-router';
import { PROTBYTE_SITE } from '../lib/links';

export function Footer() {
  return (
    <footer className="mt-16">
      <div className="border-t border-line bg-panel/60">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-3 px-4 py-6 text-xs text-ink-3 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="" width={18} height={18} className="opacity-80" />
            <span className="font-medium text-ink-2">PROTBYTE Sentinel</span>
            <span>•</span>
            <span>A free tool from PROTBYTE</span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <a
              href={PROTBYTE_SITE}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-ink-2 hover:text-accent"
            >PROTBYTE ↗</a>
            <Link to="/docs" className="hover:text-ink-2">Docs</Link>
            <Link to="/terms" className="hover:text-ink-2">Terms</Link>
            <Link to="/privacy" className="hover:text-ink-2">Privacy</Link>
            <Link to="/aup" className="hover:text-ink-2">Acceptable Use</Link>
            <a
              href="mailto:contact@protbyte.com"
              className="hover:text-ink-2"
            >Contact</a>
            <span className="text-ink-3">© {new Date().getFullYear()} PROTBYTE</span>
          </nav>
        </div>
      </div>

      {/* Terminal status bar — the tool's posture as a closing brand moment. */}
      <div className="border-t border-sky-300/20 bg-[#020617]">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-2.5 gap-y-1 px-4 py-3 font-mono text-xs tracking-[0.02em] text-ink-3 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 whitespace-nowrap">
            <span className="ok-dot" aria-hidden="true" />
            Ephemeral scans
          </span>
          <span className="text-ink-2" aria-hidden="true">·</span>
          <span className="whitespace-nowrap">No data stored</span>
          <span className="text-ink-2" aria-hidden="true">·</span>
          <span className="whitespace-nowrap">No signup</span>
          <span className="text-ink-2" aria-hidden="true">·</span>
          <span className="whitespace-nowrap">Read-only, external checks</span>
          <a
            href={PROTBYTE_SITE}
            target="_blank"
            rel="noreferrer"
            className="ml-auto whitespace-nowrap text-sky-300 hover:text-sky-200 hover:underline hover:underline-offset-4"
          >&gt; cd protbyte.com</a>
        </div>
      </div>
    </footer>
  );
}
